import styled from 'styled-components';

import DocumentsUpload from './DocumentsUpload';

export default styled(DocumentsUpload)`
  .documents-upload {
    display: flex;
    &__button-upload {
      margin: 0 0.8rem;
      padding: 0;
    }

    &__next-side {
      display: flex;
    }

    &__next-side-action {
      align-items: center;
      display: flex;
      justify-content: center;
    }

    &__finish {
      margin-right: 0.8rem;
    }

    &__next-side-label {
      color: var(--grey700);
      width: 151px;
    }

    &__error {
      color: var(--error900);
    }
  }
`;
